import { defineNuxtPlugin } from "#imports";
export default defineNuxtPlugin({
  name: "nuxt-graphql-middleware-provide-state",
  // We can set a very low order to make sure this plugin runs as early as
  // possible.
  order: -9999,
  setup() {
    const graphqlState = {
      fetchOptions: {}
    };
    return {
      provide: {
        graphqlState
      }
    };
  }
});
